import {
  GenericForm,
  GenericFormLogicalField,
  GenericFormValidationContext_forValidation,
  genericBeforeValidate_removeDefaultKeyedError,
  ValidationEvent,
} from "../../../hooks";

export interface InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland {
  recaptchaEnabled: boolean;
  recaptchaId: string;
  recaptchaJsLayout: { [key: string]: any };
  recaptchaTimeout: any;
}

export interface AppMinimumRequirementsForRecaptcha {
  initialState: { [key: string]: any };
}

export const recaptchaFormLogic = <
  Form extends GenericForm,
  App extends AppMinimumRequirementsForRecaptcha
>({
  initialStateKey,
}: {
  initialStateKey: string;
}): GenericFormLogicalField<Form, App> => ({
  validationEvents: [ValidationEvent.onChange, ValidationEvent.onSubmit],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: (
    context: GenericFormValidationContext_forValidation<Form, App>
  ): void => {
    const recaptchaContext = context.app.initialState[
      initialStateKey
    ] as InitialStateMinimumRequirements_Recaptcha_ForAnyParticularConfigurationIsland;
    if (recaptchaContext?.recaptchaEnabled) {
      let isCaptchaValid = false;

      const captchaWrapperId = recaptchaContext?.recaptchaId + "-react-wrapper";
      const recaptchaElement = (document.querySelector("#" + captchaWrapperId)?.querySelector(".g-recaptcha-response")) as HTMLTextAreaElement;

      const recaptchaInput =
        (document.querySelector(
          `#${recaptchaContext.recaptchaId}-react-wrapper > div.field > div.control > input.required-captcha.checkbox`
        ) as HTMLInputElement) ||
        document
          .querySelector("#" + recaptchaContext.recaptchaId)
          ?.querySelector(".g-recaptcha-response");

      if ((recaptchaInput && recaptchaInput.checked) || recaptchaElement?.value) {
        isCaptchaValid = true;
      }

      if (!isCaptchaValid) {
        const partialUpdate_withError = {
          [`${context.name}Error`]: "This field is required.",
        } as Partial<Form>;
        context.mutate.withPartialForm(context, partialUpdate_withError);
      }
    }
  },
});
